import { Injectable, Inject, Optional } from '@angular/core';

@Injectable()
export class NxiConfigService {
    community: string;
    constructor(@Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.community = parsemap.community;
        }
        console.log(' In config service ibdConfigMap ' + appSettings.ibdConfigMap);
        console.log(' In config service community ' + this.community);
    }

    getCommunityName(): string {
        return this.community;
    }
}
